import { useMutation, useQueryClient } from "react-query";

import { CombinationRulePostSchema } from "~/entity/CombinationRules/model/schema";

import { useCombinationRules } from "./useCombinationRules";
import { COMBINATION_RULES_QUERY_KEY } from "./useGetCombinationRules";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: CombinationRulePostSchema;
  options?: MutateOptions;
}

export const useCreateCombinationRule = (
  queryKey: string | any[] = COMBINATION_RULES_QUERY_KEY,
) => {
  const { ruleCreate } = useCombinationRules();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await ruleCreate(props.data);
      if (result.data) {
        return result.data;
      } else {
        throw new Error("Не удалось создать правило совмещения");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
    onSettled: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });

  const create = (data: CombinationRulePostSchema, options?: MutateOptions) => {
    mutation.mutate({ data, options });
  };

  return { create, isLoading: mutation.isLoading };
};
